import styled from 'styled-components';
import { InPageAlert } from '@snsw-gel/react';
import { Col, ContentContainer, Heading, Row } from '@snsw/snsw-rjsf';
import global from 'app/theme/styles/global';

const mobileBreakpoint = `${global.breakpoints.small.value}px`;

const StyledContentContainer = styled(ContentContainer)`
  padding: ${global.edgeSize.xxlarge} 10rem;
  position: relative;

  @media (max-width: ${mobileBreakpoint}) {
    padding: ${global.edgeSize.none} ${global.edgeSize.none} ${global.edgeSize.xxxlarge};
  }
`;

const UnderMaintenance: React.FC = () => {
  return (
    <StyledContentContainer style={{ paddingTop: 0 }}>
      <Row>
        <Col span={12}>
          <Heading level={1}>Scheduled maintenance</Heading>
          <InPageAlert variant="info" title="Scheduled maintenance" headingLevel="h4">
            <p>
              Service Booker will be unavailable from 5pm Monday 22 June to 8pm Monday 22 June due to scheduled
              maintenance.
            </p>
          </InPageAlert>
        </Col>
      </Row>
    </StyledContentContainer>
  );
};

export default UnderMaintenance;
